
import React, { useEffect, useState } from 'react'
import CustomLoader from '../../loader/CustomLoader';
import { headLineStyle } from '../../Layout/HeadlineStyle';
import DataTable from 'react-data-table-component';
import HttpClientXml from '../../utils/HttpClientXml';
import toast from 'react-hot-toast';
import moment from 'moment';

const customStyles = {
    rows: {
        style: {
            minHeight: '48px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
};
const Alluser = () => {
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "5rem"
        },
        {
            name: 'User Name',
            selector: row => row.userName,
        },
        {
            name: 'Email',
            selector: row => row.Email,
        },
        {
            name: 'Phone Number',
            selector: row => row.Phone,
        },
        {
            name: 'Subscription Date',
            selector: row => row.SubscriptionDate,
        },
        // {
        //     name: 'SubscriptionName',
        //     selector: row => row.SubscriptionName,
        // },
        {
            name: 'Wallet Balance',
            selector: row => row.WalletBalance,
        },
        // {
        //     name: 'Action',
        //     selector: row => row.action,
        // }
    ];
    // fetch Category DAta
    const getCategoryData = async () => {                                                               
        setIsLoading(true);
        const res = await HttpClientXml.requestData('get-user-specific-type', "POST", {});
        console.log("resGetCat", res)
        let apiData = []
        if (res && res?.status) {
            setIsLoading(false);
            apiData = res?.data?.map((item, i) => ({

                sl: i + 1,
                userName: item?.username,
                Email: item?.email,
                Phone: item?.phone ? <div>+{item?.phone_country_code}&nbsp;{item?.phone}</div> : <div></div>,
                SubscriptionDate: moment(item?.userDetail?.createdAt).format("DD-MM-YYYY"),
                SubscriptionName: item?.subscriptionModel?.name,
                WalletBalance: item?.walletBalance,
                // action: <EditDeleteIcon
                //     onClickEdit={(e) => handleEdit(item)}
                //     onClickDelete={(e) => handleDelete(item?._id)}
                // />
            }));
        } else {
            setIsLoading(false);
            toast.error("hh")
        }
        setTableData(apiData);
    }
    useEffect(() => {
        getCategoryData();
    }, [])
    return (
        <div>

            <CustomLoader loading={isLoading} />


            <div className="d-flex justify-content-end">

                <div className="form-header">
                    <section className="piechartsBox_area">
                        <div
                            style={headLineStyle}
                            className="page-headline"
                        >
                            View All Users
                        </div>
                        <div>
                            <DataTable
                                columns={columns}
                                data={tableData}
                                pagination
                                striped
                                customStyles={customStyles}
                            />
                        </div>
                    </section>
                </div>
            </div >




        </div >
    )
}

export default Alluser